export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-2xl bg-gradient-to-r from-primary-500 to-primary-600">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-background-50/20 shrink-0">
              <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-1">
                随时随地看黑料
              </h3>
              <p className="text-sm md:text-base text-background-50/80">
                手机浏览器直接访问，无需安装，即点即看黑料视频在线播放
              </p>
            </div>
          </div>
          <a
            href="#media"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50 text-primary-600 font-semibold text-sm md:text-base hover:bg-background-100 transition-colors whitespace-nowrap shrink-0 cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            进入观看
          </a>
        </div>
      </div>
    </section>
  );
}